import _ from 'lodash';
import { createSelector } from 'reselect';

import { StoreState } from '../redux/reducers/store.types';
import { RouterState } from '../types/router';
import { queryString } from '../utils';

export const getRouter = (state: StoreState): RouterState => state.router;

export const getRouteContext = (state: StoreState, params?) =>
  _.get(params, 'router') || state.router.context;

export const getRouteParams = createSelector(getRouteContext, (context) =>
  _.get(context, 'params', {}),
);

export const getRouteQuery = createSelector(getRouteContext, (context) =>
  queryString.parse(context.querystring),
);

export const getPreviousPage = createSelector(
  getRouter,
  (router: RouterState): string => router.previousPage,
);

export const getCurrentPageName = createSelector(
  getRouter,
  (router: RouterState): string => router.currentPageName,
);
